import { groupBy } from "lodash";
import { useMemo } from "react";

export const useSelectedFromStatuses = statuses =>
    useMemo(() => statuses.reduce((round, status, index) =>
        (status === "Live"
            ||
            (statuses[round] !== "Live" && (status === "Commenced" || status === "Complete"))
            ||
            (statuses[round] === "Complete" && status === "Upcoming")
        ) ? index : round, 0),
    [statuses]);

const getRoundStatus = round => {
    if (round.every(heat => heat.endTime)) return "Complete";
    if (round.some(heat => heat.startTime && !heat.endTime)) return "Live";
    if (round.some(heat => heat.endTime)) return "Commenced";
    return "Upcoming";
};

export const useDrawRounds = (heats) => {
    const rounds = useMemo(() => {
        return Object.values(groupBy(heats, h => h.group?.groupContestId != null ? h.group?.groupContestId : h.roundPosition)).map(group => {
            const roundsInGroup = groupBy(group, h => h.roundPosition);
            if (Object.values(roundsInGroup).length === 1) return {
                name: group[0].group?.roundName || group[0].round,
                heats: group,
                status: getRoundStatus(group),
                roundPosition: group[0].roundPosition,
                contestId: group[0].group?.roundContestId
            };
            return {
                name: group[0].group.name,
                contestId: group[0].group.groupContestId,
                rounds: Object.values(roundsInGroup).map(round => ({
                    name: round[0].group?.roundName || round[0].round,
                    heats: round,
                    status: getRoundStatus(round),
                    roundPosition: round[0].roundPosition,
                    contestId: round[0].group?.roundContestId
                })).sort((a, b) => a.roundPosition - b.roundPosition),
                status: getRoundStatus(group),
                isGroup: true
            };
        }).sort((a, b) => a.roundPosition - b.roundPosition);
    }, [heats]);

    const selectedRound = useSelectedFromStatuses(rounds.map(r => r.status));

    return { rounds, selectedRound };
};
